import { Icon, IconProps } from "./Icon";

export function IconDumbbell(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="m6.4 9.3 8.3 8.4.7-.7-8.3-8.4-.7.7ZM8.6 7l8.3 8.3.7-.7-8.3-8.3-.7.7ZM2.01 5.67a1.75 1.75 0 0 1-.65-2.88l1.42-1.43a1.74 1.74 0 0 1 2.47 0c.2.2.33.42.41.66L7.01.67a2.25 2.25 0 1 1 3.19 3.18L3.85 10.2A2.25 2.25 0 1 1 .66 7.02l1.35-1.35Zm.06-1.12a.74.74 0 0 0 1.05 0l1.43-1.42a.75.75 0 0 0 0-1.06.74.74 0 0 0-1.06 0L2.06 3.5a.75.75 0 0 0 .01 1.05Zm-.7 4.95a1.25 1.25 0 0 0 1.77 0l6.35-6.36a1.25 1.25 0 1 0-1.77-1.77L1.37 7.72a1.26 1.26 0 0 0 0 1.78Zm20.62 8.84a1.75 1.75 0 0 1 .65 2.88l-1.43 1.43a1.74 1.74 0 0 1-2.46-.01 1.74 1.74 0 0 1-.41-.65l-1.36 1.35a2.25 2.25 0 1 1-3.18-3.18l6.35-6.35a2.25 2.25 0 1 1 3.19 3.18l-1.35 1.35Zm-.06 1.12a.74.74 0 0 0-1.06-.01l-1.42 1.43a.75.75 0 0 0 0 1.05.74.74 0 0 0 1.06 0l1.42-1.42a.75.75 0 0 0 0-1.05Zm.7-4.95a1.25 1.25 0 0 0-1.77 0l-6.35 6.35a1.25 1.25 0 1 0 1.77 1.77l6.35-6.35a1.26 1.26 0 0 0 0-1.77Z"
      />
    </Icon>
  );
}
